import React from 'react';

// NOTE: v1 placeholder artwork. Designer pass pending.
export default function HalloweenAccessory() {
  return (
    <g aria-hidden="true">
      {/* Pumpkin sitting on the roof */}
      <ellipse cx="100" cy="74" rx="22" ry="18" fill="#E89A2E" />
      <ellipse cx="84" cy="74" rx="6" ry="17" fill="#CD7F32" opacity="0.5" />
      <ellipse cx="116" cy="74" rx="6" ry="17" fill="#CD7F32" opacity="0.5" />
      {/* Stem */}
      <path d="M96,55 L96,62 L104,62 L104,55 Z" fill="#009159" />
      {/* Leaf */}
      <path d="M104,57 Q112,52 114,58 Q110,60 104,60" fill="#92D400" />
      {/* Jack-o-lantern face */}
      <path d="M88,70 L94,66 L94,72 Z" fill="#131313" />
      <path d="M112,70 L106,66 L106,72 Z" fill="#131313" />
      <path d="M88,80 Q94,84 100,82 Q106,84 112,80 Q108,86 100,86 Q92,86 88,80 Z" fill="#131313" />
      {/* Cobwebs in corners */}
      <g opacity="0.5">
        <path d="M24,135 L42,140 M26,128 L42,140 M26,148 L42,140 M22,142 L42,140" stroke="#F9FCF1" strokeWidth="0.7" fill="none" />
        <path d="M176,135 L158,140 M174,128 L158,140 M174,148 L158,140 M178,142 L158,140" stroke="#F9FCF1" strokeWidth="0.7" fill="none" />
      </g>
    </g>
  );
}
